import { fetcher } from 'services/helpers/responseHandler'

const stats = async () => fetcher.get('FactDailySubscription/stats')

const optInStats = async ({ startDate, endDate }) =>
  fetcher.get('FactDailySubscription/overtime-opt-in', {
    fromDate: startDate,
    toDate: endDate
  })

const optOutStats = async ({ startDate, endDate }) =>
  fetcher.get('FactDailySubscription/overtime-opt-out', {
    fromDate: startDate,
    toDate: endDate
  })

const getConsentUploads = async ({ startDate, endDate }) =>
  fetcher.get(`accounts/upload/history?FromDate=${startDate}&ToDate=${endDate}`)

const complianceApi = {
  stats,
  optInStats,
  optOutStats,
  getConsentUploads
}

export default complianceApi
